<script lang="ts">
  import { comprehensive, coordinate } from "./stores";

  const pattern = /^\s*-?[0-9]+(\.[0-9]+)?\s*$/;

  let verified: boolean;
  let x: string = $coordinate[0];
  let y: string = $coordinate[1];

  $: verified = pattern.test(x) && pattern.test(y);

  const handleSubmit = () => {
    if (verified) {
      comprehensive.set(false);
      coordinate.set([x.trim(), y.trim()]);
    }
  };
</script>

<header class="container">
  <div class="heading">
    <h1 class="title">Finn posisjon</h1>
  </div>
  <form class="form" on:submit|preventDefault={handleSubmit}>
    <input class="input" id="first-input" placeholder="569400.383" type="text" bind:value={x} />
    <input class="input" id="second-input" placeholder="6668087.248" type="text" bind:value={y} />
    <button class="btn btn-primary" disabled={!verified} type="submit">Finn posisjon</button>
  </form>
  <div class="menu">
  </div>
</header>

<style>
  .container {
    align-items: center;
    background-color: #fff;
    border-bottom: solid 1px #222;
    display: flex;
    height: 80px;
    justify-content: space-between;
    left: 0px;
    padding: 0 16px;
    position: absolute;
    right: 0px;
    top: 0px;
  }
  .heading {
    text-align: left;
    width: 30%;
  }
  .form {
    align-items: center;
    display: flex;
    width: 40%;
  }
  .menu {
    text-align: right;
    width: 30%;
  }
  .title {
    font-size: 1.5rem;
    font-weight: lighter;
  }
  .input {
    background-color: #fff;
    border: solid 1px #222;
    border-radius: 4px;
    margin-right: 8px;
    padding: 0.375rem 0.75rem;
    width: 100%;
  }
</style>
